module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/instagram/chapel_sns_06-e0bd3f29f917c3d91ddf86a666f3127d.jpg";